exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#rows[data-v-f59347a8] {\n  color: black;\n}\n#view-button[data-v-f59347a8] {\n  background: none;\n  border: none;\n  padding: 0;\n  box-shadow: none;\n  outline: none;\n}\n#view-button i[data-v-f59347a8] {\n  color: #1c869a;\n  font-size: 22px;\n}\n#view-button i[data-v-f59347a8]:hover {\n  color: #31bdda;\n  transition: 0.5s;\n}\n", ""]);

// exports
